import React from 'react';
import { Typography, Button } from '@material-ui/core';
import styled from 'styled-components';
import { ConfirmModal, DialogBox } from '@mummssoftware/common-ui';
import defaults from '../../../../translations/en.json';

export const RecordVisitButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 20px;
  margin: 1rem;
`;

type ConfirmHCPCSDialogProps = {
  open: boolean;
  onRecord: () => void;
  onCancel: () => void;
};

export const ConfirmHCPCSDialog = ({
  open,
  onRecord,
  onCancel,
}: ConfirmHCPCSDialogProps) => (
  <DialogBox
    title={defaults.recordHCPCS}
    handleClick={() => null}
    open={open}
    noIcon
    BackdropProps={{ invisible: true }}
  >
    <>
      <Typography>{defaults.recordHCPCSconfirm}</Typography>
      <RecordVisitButtonsDiv>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={onRecord}
        >
          {defaults.yes}
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={onCancel}
        >
          {defaults.cancel}
        </Button>
      </RecordVisitButtonsDiv>
    </>
  </DialogBox>
);
